// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1164":"dce156d9","2049":"cf798b84","4382":"dce156d9","6149":"f2d12f40","7291":"dce156d9","8320":"7dac56b2","9178":"cf798b84"}[chunkId] + ".chunk.css";
};